import { render, staticRenderFns } from "./PrimarySkill.vue?vue&type=template&id=cfdf96d8&scoped=true&"
import script from "./PrimarySkill.vue?vue&type=script&lang=js&"
export * from "./PrimarySkill.vue?vue&type=script&lang=js&"
import style0 from "./PrimarySkill.vue?vue&type=style&index=0&id=cfdf96d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdf96d8",
  null
  
)

export default component.exports